// @ts-check
import React, { FC } from 'react'; // eslint-disable-line no-unused-vars
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';

/** @typedef {{
  name: string,
  value: number
}} DataElem */

/** @typedef {{
  data: Record<string, any>[],
  labelKey: string
  valueKey: string,
}} VerticalBarChartProps */

/** @type { FC<VerticalBarChartProps> } */
export const VerticalBarChart = props => {
  const { data, labelKey, valueKey } = props;

  const height = 50 * Math.max(5, 2 * Math.log2(data.length) + 1);

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart layout="vertical" data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number" />
        <YAxis dataKey={labelKey} type="category" width={90} />
        <Tooltip />
        <Legend />
        <Bar dataKey={valueKey} fill="#8884d8" />
        {/* <Bar dataKey="uv" stroke="82ca9d" /> */}
      </BarChart>
    </ResponsiveContainer>
  );
};
